import { jsx as g, jsxs as m } from "react/jsx-runtime";
import { createContext as L, useContext as I, useCallback as B, forwardRef as c } from "react";
const W = "@gjensidige/core-analytics", Y = "16.0.13", j = "not-set", h = "application_module", b = "event_module", E = {
  [h]: j,
  application_name: j,
  business_area: j,
  customer_segment: j,
  event_source: W,
  event_version: Y
}, Z = (_, a, e) => O({ ...a, ..._ }, "link", e), q = L({
  options: { ...E }
});
let $ = 0;
function O(_ = {}, a, e) {
  var l;
  const o = (l = window.utag) == null ? void 0 : l[a].bind(window.utag);
  o ? e ? o(C(_), e) : o(C(_)) : $ < 10 ? setTimeout(() => O(_, a), 100, $++) : console.error(`window.utag.${a} not found `, _);
}
function C(_) {
  const a = { ...E };
  return Object.entries(_).forEach(([e, l]) => {
    const o = e === "eventLabel" || e === "eventStatus", t = e.replace(/[A-Z]/g, "_$&").toLowerCase();
    o && l && (l = `${l}`.toLowerCase().split(" ").join("-")), a[t] = l;
  }), {
    ...a,
    [b]: a[b] || a[h],
    page_pathname: a.page_pathname || z(a),
    measure_source: a.event_source,
    measure_version: a.event_version
  };
}
function z(_) {
  return `${window.location.pathname.replace(/\/$/, "")}/${_.application_name}/${_[h]}/${_.scenario_name}/${_.scenario_step}`.replace(/\/(undefined|null|not-set)/g, "").replace("/Din+side/", "/Din-side/");
}
function A(_) {
  var a, e, l = "";
  if (typeof _ == "string" || typeof _ == "number")
    l += _;
  else if (typeof _ == "object")
    if (Array.isArray(_)) {
      var o = _.length;
      for (a = 0; a < o; a++)
        _[a] && (e = A(_[a])) && (l && (l += " "), l += e);
    } else
      for (e in _)
        _[e] && (l && (l += " "), l += e);
  return l;
}
function u() {
  for (var _, a, e = 0, l = "", o = arguments.length; e < o; e++)
    (_ = arguments[e]) && (a = A(_)) && (l && (l += " "), l += a);
  return l;
}
const J = "@gjensidige/builders-components", K = "1.4.1";
function Q(_) {
  const { options: a } = I(q);
  return B(
    (e) => {
      _ && Z(
        {
          eventVersion: K,
          eventSource: J,
          eventLabel: "",
          ...e,
          ..._ === !0 ? {} : _
        },
        a
      );
    },
    [_, a]
  );
}
function X(_) {
  return _ instanceof HTMLElement ? (_.innerText || _.textContent || _.getAttribute("aria-label") || "").replace(/\n/g, " ").trim() : "";
}
const __ = (_) => /* @__PURE__ */ g("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ..._, children: /* @__PURE__ */ g("path", { d: "M11 13L22 2M22 2H14M22 2V10M9 2H2V22H22V15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), a_ = "_flex_1fuja_3", l_ = "_fill_1fuja_10", e_ = "_inline_1fuja_23", o_ = "_column_1fuja_24", s = {
  flex: a_,
  fill: l_,
  inline: e_,
  column: o_,
  "column-reverse": "_column-reverse_1fuja_25",
  "row-reverse": "_row-reverse_1fuja_26",
  "wrap-reverse": "_wrap-reverse_1fuja_27",
  "wrap-nowrap": "_wrap-nowrap_1fuja_28",
  "align-start": "_align-start_1fuja_33",
  "align-center": "_align-center_1fuja_34",
  "align-end": "_align-end_1fuja_35",
  "align-baseline": "_align-baseline_1fuja_36",
  "align-stretch": "_align-stretch_1fuja_37",
  "align-content-start": "_align-content-start_1fuja_40",
  "align-content-center": "_align-content-center_1fuja_41",
  "align-content-end": "_align-content-end_1fuja_42",
  "align-content-stretch": "_align-content-stretch_1fuja_43",
  "align-content-baseline": "_align-content-baseline_1fuja_44",
  "align-content-space-around": "_align-content-space-around_1fuja_45",
  "align-content-space-between": "_align-content-space-between_1fuja_46",
  "align-content-space-evenly": "_align-content-space-evenly_1fuja_47",
  "justify-start": "_justify-start_1fuja_49",
  "justify-center": "_justify-center_1fuja_50",
  "justify-end": "_justify-end_1fuja_51",
  "justify-space-around": "_justify-space-around_1fuja_52",
  "justify-space-between": "_justify-space-between_1fuja_53",
  "justify-space-evenly": "_justify-space-evenly_1fuja_54",
  "center-md": "_center-md_1fuja_56",
  "center-lg": "_center-lg_1fuja_57",
  "center-xl": "_center-xl_1fuja_57",
  "center-xxl": "_center-xxl_1fuja_57",
  "xs-10.2": "_xs-10.2_1fuja_74",
  "xs-2.1": "_xs-2.1_1fuja_74",
  "xs-3.9": "_xs-3.9_1fuja_76",
  "xs-9.3": "_xs-9.3_1fuja_76",
  "xs-4.8": "_xs-4.8_1fuja_77",
  "xs-8.4": "_xs-8.4_1fuja_77",
  "xs-5.7": "_xs-5.7_1fuja_78",
  "xs-7.5": "_xs-7.5_1fuja_78",
  "xs-0": "_xs-0_1fuja_82",
  "xs-1": "_xs-1_1fuja_74",
  "xs-2": "_xs-2_1fuja_74",
  "xs-3": "_xs-3_1fuja_76",
  "xs-4": "_xs-4_1fuja_77",
  "xs-6": "_xs-6_1fuja_83",
  "xs-row-gap-none": "_xs-row-gap-none_1fuja_85",
  "xs-col-gap-none": "_xs-col-gap-none_1fuja_85",
  "xs-row-gap-xs": "_xs-row-gap-xs_1fuja_86",
  "xs-col-gap-xs": "_xs-col-gap-xs_1fuja_86",
  "xs-row-gap-sm": "_xs-row-gap-sm_1fuja_87",
  "xs-col-gap-sm": "_xs-col-gap-sm_1fuja_87",
  "xs-row-gap-md": "_xs-row-gap-md_1fuja_88",
  "xs-col-gap-md": "_xs-col-gap-md_1fuja_88",
  "xs-row-gap-lg": "_xs-row-gap-lg_1fuja_89",
  "xs-col-gap-lg": "_xs-col-gap-lg_1fuja_89",
  "xs-row-gap-xl": "_xs-row-gap-xl_1fuja_90",
  "xs-col-gap-xl": "_xs-col-gap-xl_1fuja_90",
  "sm-2.1": "_sm-2.1_1fuja_93",
  "sm-10.2": "_sm-10.2_1fuja_93",
  "sm-3.9": "_sm-3.9_1fuja_95",
  "sm-9.3": "_sm-9.3_1fuja_95",
  "sm-4.8": "_sm-4.8_1fuja_97",
  "sm-8.4": "_sm-8.4_1fuja_97",
  "sm-5.7": "_sm-5.7_1fuja_99",
  "sm-7.5": "_sm-7.5_1fuja_99",
  "sm-0": "_sm-0_1fuja_101",
  "sm-1": "_sm-1_1fuja_93",
  "sm-2": "_sm-2_1fuja_93",
  "sm-3": "_sm-3_1fuja_95",
  "sm-4": "_sm-4_1fuja_97",
  "sm-6": "_sm-6_1fuja_102",
  "sm-row-gap-none": "_sm-row-gap-none_1fuja_104",
  "sm-col-gap-none": "_sm-col-gap-none_1fuja_104",
  "sm-row-gap-xs": "_sm-row-gap-xs_1fuja_105",
  "sm-col-gap-xs": "_sm-col-gap-xs_1fuja_105",
  "sm-row-gap-sm": "_sm-row-gap-sm_1fuja_106",
  "sm-col-gap-sm": "_sm-col-gap-sm_1fuja_106",
  "sm-row-gap-md": "_sm-row-gap-md_1fuja_107",
  "sm-col-gap-md": "_sm-col-gap-md_1fuja_107",
  "sm-row-gap-lg": "_sm-row-gap-lg_1fuja_108",
  "sm-col-gap-lg": "_sm-col-gap-lg_1fuja_108",
  "sm-row-gap-xl": "_sm-row-gap-xl_1fuja_109",
  "sm-col-gap-xl": "_sm-col-gap-xl_1fuja_109",
  "md-2.1": "_md-2.1_1fuja_113",
  "md-10.2": "_md-10.2_1fuja_113",
  "md-3.9": "_md-3.9_1fuja_115",
  "md-9.3": "_md-9.3_1fuja_115",
  "md-4.8": "_md-4.8_1fuja_117",
  "md-8.4": "_md-8.4_1fuja_117",
  "md-5.7": "_md-5.7_1fuja_119",
  "md-7.5": "_md-7.5_1fuja_119",
  "md-0": "_md-0_1fuja_121",
  "md-1": "_md-1_1fuja_113",
  "md-2": "_md-2_1fuja_113",
  "md-3": "_md-3_1fuja_115",
  "md-4": "_md-4_1fuja_117",
  "md-6": "_md-6_1fuja_122",
  "md-row-gap-none": "_md-row-gap-none_1fuja_124",
  "md-col-gap-none": "_md-col-gap-none_1fuja_124",
  "md-row-gap-xs": "_md-row-gap-xs_1fuja_125",
  "md-col-gap-xs": "_md-col-gap-xs_1fuja_125",
  "md-row-gap-sm": "_md-row-gap-sm_1fuja_126",
  "md-col-gap-sm": "_md-col-gap-sm_1fuja_126",
  "md-row-gap-md": "_md-row-gap-md_1fuja_127",
  "md-col-gap-md": "_md-col-gap-md_1fuja_127",
  "md-row-gap-lg": "_md-row-gap-lg_1fuja_128",
  "md-col-gap-lg": "_md-col-gap-lg_1fuja_128",
  "md-row-gap-xl": "_md-row-gap-xl_1fuja_129",
  "md-col-gap-xl": "_md-col-gap-xl_1fuja_129",
  "lg-2.1": "_lg-2.1_1fuja_133",
  "lg-10.2": "_lg-10.2_1fuja_133",
  "lg-3.9": "_lg-3.9_1fuja_135",
  "lg-9.3": "_lg-9.3_1fuja_135",
  "lg-4.8": "_lg-4.8_1fuja_137",
  "lg-8.4": "_lg-8.4_1fuja_137",
  "lg-5.7": "_lg-5.7_1fuja_139",
  "lg-7.5": "_lg-7.5_1fuja_139",
  "lg-0": "_lg-0_1fuja_141",
  "lg-1": "_lg-1_1fuja_133",
  "lg-2": "_lg-2_1fuja_133",
  "lg-3": "_lg-3_1fuja_135",
  "lg-4": "_lg-4_1fuja_137",
  "lg-6": "_lg-6_1fuja_142",
  "lg-row-gap-none": "_lg-row-gap-none_1fuja_144",
  "lg-col-gap-none": "_lg-col-gap-none_1fuja_144",
  "lg-row-gap-xs": "_lg-row-gap-xs_1fuja_145",
  "lg-col-gap-xs": "_lg-col-gap-xs_1fuja_145",
  "lg-row-gap-sm": "_lg-row-gap-sm_1fuja_146",
  "lg-col-gap-sm": "_lg-col-gap-sm_1fuja_146",
  "lg-row-gap-md": "_lg-row-gap-md_1fuja_147",
  "lg-col-gap-md": "_lg-col-gap-md_1fuja_147",
  "lg-row-gap-lg": "_lg-row-gap-lg_1fuja_148",
  "lg-col-gap-lg": "_lg-col-gap-lg_1fuja_148",
  "lg-row-gap-xl": "_lg-row-gap-xl_1fuja_149",
  "lg-col-gap-xl": "_lg-col-gap-xl_1fuja_149",
  "xl-2.1": "_xl-2.1_1fuja_153",
  "xl-10.2": "_xl-10.2_1fuja_153",
  "xl-3.9": "_xl-3.9_1fuja_155",
  "xl-9.3": "_xl-9.3_1fuja_155",
  "xl-4.8": "_xl-4.8_1fuja_157",
  "xl-8.4": "_xl-8.4_1fuja_157",
  "xl-5.7": "_xl-5.7_1fuja_159",
  "xl-7.5": "_xl-7.5_1fuja_159",
  "xl-0": "_xl-0_1fuja_161",
  "xl-1": "_xl-1_1fuja_153",
  "xl-2": "_xl-2_1fuja_153",
  "xl-3": "_xl-3_1fuja_155",
  "xl-4": "_xl-4_1fuja_157",
  "xl-6": "_xl-6_1fuja_162",
  "xl-row-gap-none": "_xl-row-gap-none_1fuja_164",
  "xl-col-gap-none": "_xl-col-gap-none_1fuja_164",
  "xl-row-gap-xs": "_xl-row-gap-xs_1fuja_165",
  "xl-col-gap-xs": "_xl-col-gap-xs_1fuja_165",
  "xl-row-gap-sm": "_xl-row-gap-sm_1fuja_166",
  "xl-col-gap-sm": "_xl-col-gap-sm_1fuja_166",
  "xl-row-gap-md": "_xl-row-gap-md_1fuja_167",
  "xl-col-gap-md": "_xl-col-gap-md_1fuja_167",
  "xl-row-gap-lg": "_xl-row-gap-lg_1fuja_168",
  "xl-col-gap-lg": "_xl-col-gap-lg_1fuja_168",
  "xl-row-gap-xl": "_xl-row-gap-xl_1fuja_169",
  "xl-col-gap-xl": "_xl-col-gap-xl_1fuja_169",
  "xxl-2.1": "_xxl-2.1_1fuja_173",
  "xxl-10.2": "_xxl-10.2_1fuja_173",
  "xxl-3.9": "_xxl-3.9_1fuja_175",
  "xxl-9.3": "_xxl-9.3_1fuja_175",
  "xxl-4.8": "_xxl-4.8_1fuja_177",
  "xxl-8.4": "_xxl-8.4_1fuja_177",
  "xxl-5.7": "_xxl-5.7_1fuja_179",
  "xxl-7.5": "_xxl-7.5_1fuja_179",
  "xxl-0": "_xxl-0_1fuja_181",
  "xxl-1": "_xxl-1_1fuja_173",
  "xxl-2": "_xxl-2_1fuja_173",
  "xxl-3": "_xxl-3_1fuja_175",
  "xxl-4": "_xxl-4_1fuja_177",
  "xxl-6": "_xxl-6_1fuja_182",
  "xxl-row-gap-none": "_xxl-row-gap-none_1fuja_184",
  "xxl-col-gap-none": "_xxl-col-gap-none_1fuja_184",
  "xxl-row-gap-xs": "_xxl-row-gap-xs_1fuja_185",
  "xxl-col-gap-xs": "_xxl-col-gap-xs_1fuja_185",
  "xxl-row-gap-sm": "_xxl-row-gap-sm_1fuja_186",
  "xxl-col-gap-sm": "_xxl-col-gap-sm_1fuja_186",
  "xxl-row-gap-md": "_xxl-row-gap-md_1fuja_187",
  "xxl-col-gap-md": "_xxl-col-gap-md_1fuja_187",
  "xxl-row-gap-lg": "_xxl-row-gap-lg_1fuja_188",
  "xxl-col-gap-lg": "_xxl-col-gap-lg_1fuja_188",
  "xxl-row-gap-xl": "_xxl-row-gap-xl_1fuja_189",
  "xxl-col-gap-xl": "_xxl-col-gap-xl_1fuja_189"
}, M = c(function({
  align: _,
  alignContent: a,
  as: e,
  center: l = !1,
  className: o,
  direction: t = "row",
  fill: n,
  gap: r = "md",
  inline: f,
  justify: d,
  layout: w = {},
  wrap: i = "wrap",
  ...G
}, H) {
  const U = e || "div", V = N(r).flatMap(([p, v]) => {
    const [k, R = k] = v.trim().split(" ");
    return [
      s[`${p}-row-gap-${k}`],
      s[`${p}-col-gap-${R}`]
    ];
  }), P = N(w).map(
    ([p, v]) => s[`${p}-${Number(`${v}`.replace("auto", "0"))}`]
    // Convert to number to convert 2.10 to 2.1 and false to 0
  );
  return /* @__PURE__ */ g(
    U,
    {
      ...G,
      className: u(
        s.flex,
        !n || s.fill,
        !f || s.inline,
        s[t],
        s[`align-${_}`],
        s[`align-content-${a}`],
        s[`center-${l === !0 ? "xxl" : l}`],
        s[`justify-${d}`],
        s[`wrap-${i}`],
        ...V,
        ...P,
        o
      ),
      ref: H
    }
  );
}), N = (_) => Object.entries(typeof _ == "object" ? _ : { xs: _ }), n_ = "_link_loc0i_3", s_ = "_external_loc0i_18", F = {
  link: n_,
  external: s_
}, t_ = c(function({
  as: _,
  children: a,
  className: e,
  icon: l = "auto",
  onClick: o,
  tracking: t = !0,
  ...n
}, r) {
  const f = _ || "a", d = Q(t), w = (i) => {
    d({
      eventCategory: "link",
      eventAction: "click",
      eventLabel: X(i.currentTarget)
    }), o == null || o(i);
  };
  return n.target === "_blank" && Object.assign(n, { rel: "noreferrer noopener" }), /* @__PURE__ */ m(
    f,
    {
      className: u(F.link, e),
      onClick: w,
      ref: r,
      ...n,
      children: [
        a,
        n.target === "_blank" && l && /* @__PURE__ */ g(__, { className: F.external })
      ]
    }
  );
}), g_ = {
  copyright: "Copyright © Gjensidige",
  editCookies: "Ret cookieindstillinger"
}, S = {
  copyright: "Copyright © Gjensidige",
  editCookies: "Edit cookie consent"
}, r_ = {
  copyright: "Opphavsrett © Gjensidige",
  editCookies: "Endre cookieinnstillinger"
}, x_ = {
  copyright: "© %year Gjensidige Försäkring",
  editCookies: "Ändra cookieinställningar"
}, y = { da: g_, en: S, nb: r_, sv: x_ }, T = L(S), c_ = "_footer_1kgpc_6", u_ = "_nav_1kgpc_29", f_ = "_social_1kgpc_34", i_ = "_extras_1kgpc_76", p_ = "_extrasItems_1kgpc_88", j_ = "_copyright_1kgpc_92", x = {
  footer: c_,
  nav: u_,
  social: f_,
  extras: i_,
  extrasItems: p_,
  copyright: j_
}, m_ = (/* @__PURE__ */ new Date()).getFullYear(), D = c(
  function({ label: a, className: e, icon: l, tracking: o = !0, ...t }, n) {
    const r = Object.assign({ eventCategory: "footer-item" }, o), f = u(x.item, e);
    return /* @__PURE__ */ m(
      t_,
      {
        ...t,
        className: f,
        icon: !l,
        ref: n,
        tracking: o && r,
        children: [
          l,
          a
        ]
      }
    );
  }
), d_ = c(
  function({ children: a, className: e, ...l }, o) {
    const { editCookies: t, copyright: n } = I(T), r = u(x.extras, e);
    return /* @__PURE__ */ m(M, { layout: "9.3", ...l, className: r, ref: o, children: [
      /* @__PURE__ */ m("div", { className: x.extrasItems, children: [
        /* @__PURE__ */ g(
          D,
          {
            label: t,
            href: "#cookie:settings",
            onClick: () => {
              "UC_UI" in window && UC_UI.showSecondLayer();
            }
          }
        ),
        a
      ] }),
      /* @__PURE__ */ g("div", { className: x.copyright, children: n.replace("%year", m_.toString()) })
    ] });
  }
), w_ = c(
  function({ className: a, ...e }, l) {
    const o = u(x.nav, a);
    return /* @__PURE__ */ g("div", { ...e, className: o, ref: l });
  }
), v_ = c(
  function({ className: a, ...e }, l) {
    const o = u(x.social, a);
    return /* @__PURE__ */ g("div", { ...e, className: o, ref: l });
  }
), y_ = c(function({ className: a, language: e, ...l }, o) {
  const t = u(x.footer, a);
  let n = y[e];
  return n || (n = y.en, console.warn(
    `core-footer could not start with language "${e}"
      - Please use one of: "${Object.keys(y).join('", "')}"
      - Fallback to english enabled`
  )), /* @__PURE__ */ g(T.Provider, { value: n, children: /* @__PURE__ */ g(
    M,
    {
      as: "footer",
      gap: "xl md",
      center: !0,
      layout: { xs: 1, sm: 2, lg: 3, xl: 4 },
      className: t,
      ref: o,
      ...l
    }
  ) });
}), b_ = Object.assign(y_, {
  Extras: d_,
  Item: D,
  Nav: w_,
  Social: v_
});
export {
  b_ as Footer,
  y_ as FooterComp
};
//# sourceMappingURL=footer.js.map
